import type {
  UpdateMessageMutation,
  UpdateMessageMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#src/graphql/fragments/message-fields';

export const UPDATE_MESSAGE: TypedDocumentNode<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      ...MessageFields
    }
  }
`;
